import React from "react";
import { Navigate } from "react-router-dom";
import { useEventsFeature } from "@/contexts/EventsFeatureContext";
import EventsComingSoonPage from "@/components/Site/features/events/EventsComingSoonPage";

const GateFallback: React.FC = () => (
  <div
    style={{
      minHeight: "40vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  />
);

/** Blocks public /events routes when the Vercel `events` flag is off. */
export const PublicEventsRouteGate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { ready, eventsEnabled } = useEventsFeature();
  if (!ready) {
    return <GateFallback />;
  }
    if (!eventsEnabled) {
    return <EventsComingSoonPage />;
  }
  return <>{children}</>;
};

/**
 * Blocks host `/dashboard/events/*` when the flag is off.
 * Do not wrap `/admin/*` — platform admin is a separate portal (see PlatformAdminRouteGate).
 */
export const DashboardEventsRouteGate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { ready, eventsEnabled } = useEventsFeature();
  if (!ready) {
    return <GateFallback />;
  }
  if (!eventsEnabled) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};
